import { ZfBox, ZfTypography } from '@zafire/react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useClient, useTopics } from '../../api';
import { AdminTopicCard } from '../../components/admin';

const GRID_GAP = 25;
const PADDING = 25;
const ADMIN_TOPIC_GRID_COLUMNS = 4;

export const AdminTopics = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { data: client } = useClient();
    const { data: topics } = useTopics();
    const pinnedTopicIds = client?.talkingPointPins.map((pin) => pin.topicId) ?? [];

    if (!topics) return null;

    return (
        <ZfBox
            style={{
                display: 'flex',
                flexDirection: 'column',
                flex: 1,
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: '#141e55',
            }}
        >
            <ZfBox
                style={{
                    display: 'grid',
                    gap: `${GRID_GAP}px`,
                    padding: `${PADDING}px`,
                    gridTemplateColumns: `repeat(${ADMIN_TOPIC_GRID_COLUMNS}, 15vw)`,
                    gridTemplateRows: `repeat(2, 15vw)`,
                }}
            >
                <ZfBox
                    style={{
                        height: '100%',
                        minWidth: 0,
                        gridColumn: 1,
                        gridRow: 1,
                        border: '1px solid var(--fg-color-action-subtle-strong)',
                        padding: '16px',
                        borderRadius: '3px',
                        display: 'flex',
                        overflow: 'hidden',
                        aspectRatio: 1,
                    }}
                >
                    <ZfTypography variant="body-extra-large" style={{ color: '#fff', alignSelf: 'flex-end', maxWidth: '360px' }}>
                        {t('welcome')}
                    </ZfTypography>
                </ZfBox>
                {topics.map((topic, i) => (
                    <AdminTopicCard
                        key={i}
                        topic={topic}
                        inverted={i > 2}
                        isPinned={pinnedTopicIds.includes(topic.id)}
                        onTopicClick={() => navigate(topic.id.toString())}
                    />
                ))}
            </ZfBox>
        </ZfBox>
    );
};
